import cloneDeep from 'clone-deep'
import { InputFileTable, InputType } from 'config'
import { defaultInputs as trustLedgerDefaultInputs, header } from 'pages/Loan/Servicing/TrustLedger/constants'
import { setLoanNumber } from 'utils/setLoanNumber'

export { header }

export const getDefaultInputs = (projectId?: string): Record<string, InputType> => {
  const loanNumber = setLoanNumber()
  const inputs = cloneDeep(trustLedgerDefaultInputs())
  if (inputs.files) {
    const suffix = projectId ? `/${projectId}` : ''
    ;(inputs.files as InputFileTable).filePath = `loan/${loanNumber}/reo/improvementLedger${suffix}`
  }
  return inputs
}
